import {
  addDoc,
  collection,
  getDocs,
  getFirestore,
  orderBy,
  query,
  where,
} from "@firebase/firestore";

const firestore = getFirestore();

export async function fetchBehaviourTimelineEntries(admissionNo) {
  const timelineQuery = query(
    collection(firestore, "behaviour_timeline"),
    where("admissionNo", "==", admissionNo),
    orderBy("date", "desc")
  );
  const timelineEntries = await getDocs(timelineQuery);
  if (timelineEntries.empty) {
    throw new Error(`No behaviour timeline entries found for admission no: ${admissionNo}`);
  }
  const timelines = [];
  timelineEntries.forEach((timeline) => {
    if (timeline.exists()) timelines.push({ ...timeline.data(), id: timeline.id });
  });
  return timelines;
}

export async function addBehaviourTimelineEntries(timelineEntry) {
  const behaviourTimelineCollRef = collection(firestore, "behaviour_timeline");
  await addDoc(behaviourTimelineCollRef, timelineEntry);
}

export async function fetchStudentInOutHistory(admissionNo) {
  const inOutHistoryRef = collection(firestore, "inout_history");
  const inoutQuery = query(
    inOutHistoryRef,
    where("admissionNo", "==", admissionNo),
    orderBy("time", "desc")
  );
  const inoutEntries = await getDocs(inoutQuery);
  if (inoutEntries.empty) return [];
  const inout = [];
  inoutEntries.forEach((entry) => {
    if (entry.exists()) inout.push(entry.data());
  });
  return inout;
}
